import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import * as Yup from 'yup';
import Header from '../../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { addKitProduct, deleteKitDetails, editKitProduct, getKitcategory, getKitProduct, getKitProductData, getKitsubcategory, viewKitProduct } from '../../../redux/slice/kitproduct.slice';
import DeleteIcon from '@mui/icons-material/Delete';

const validationSchemas =
    Yup.object({
        KitName: Yup.string().required("Please enter Name"),
        KitDetails: Yup.array().of(
            Yup.object({
                KitCatogory: Yup.string().required('Catogory is required'),
                KitSubCatogory: Yup.string().required('Sub Catogory is required'),
                KitProductName: Yup.string().required('Product Name is required'),
                KitDiscription: Yup.string().required('Discription is required'),
                // KitUnit: Yup.string().required("Unit Of Measurement is required"),
                // KitQty: Yup.string().required('Qty is required'),
            })
        )
    });

const initialValues = {
    KitName: '',
    KitDetails: [{
        KitCatogory: '',
        KitSubCatogory: '',
        KitProductName: '',
        KitDiscription: '',
        KitUnit: '',
        KitQty: '',
    }]
};

const AddKitProduct = () => {

    const { state } = useLocation();
    const id = state?._id;
    const [kitdata, setkitdata] = useState(initialValues.KitDetails)
    const theme = useTheme();
    const dispatch = useDispatch();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isMobile = useMediaQuery('(max-width:500px)');
    const navigate = useNavigate();
    const categories = useSelector(state => state.kitproduct.category);
    const subcategories = useSelector(state => state.kitproduct.subCategory);
    const productData = useSelector(state => state.kitproduct.products)
    const kitproductData = useSelector(state => state.kitproduct.kitproduct)
    const [filteredProducts, setFilteredProducts] = useState([]);
    const isDataFetched = useRef(false);

    useEffect(() => {
        dispatch(getKitcategory());
        dispatch(getKitsubcategory());
        dispatch(getKitProductData());
    }, []);

    React.useEffect(() => {
        if (id) {
            dispatch(viewKitProduct(id)).then((response) => {
                if (response.payload) {
                    const kitData = response.payload;
                    setValues({
                        ...kitData,
                        KitDetails: [...kitData.KitDetails],
                    });
                    setkitdata([...kitData.KitDetails]);
                    const newFilteredProducts = kitData.KitDetails.map(detail => {
                        const productsForCategory = productData?.filter(product => product.mainCategory === detail.KitCatogory);
                        return productsForCategory;
                    });
                    setFilteredProducts(newFilteredProducts);
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [id, productData]);
    const handleAddKit = () => {
        const newKit = {
            KitCatogory: '',
            KitSubCatogory: '',
            KitProductName: '',
            KitDiscription: '',
            KitUnit: '',
            KitQty: '',
        };

        setkitdata([...kitdata, newKit]);
        setFieldValue('KitDetails', [...values.KitDetails, newKit]);
    }
    const handleSubmit = async (values, { setTouched }) => {
        const touchedFields = {};
        Object.keys(values).forEach(key => {
            if (Array.isArray(values[key])) {
                touchedFields[key] = values[key].map(() => (
                    Object.keys(validationSchemas.fields[key].innerType.fields).reduce((acc, field) => {
                        acc[field] = true;
                        return acc;
                    }, {})
                ));
            } else {
                touchedFields[key] = true;
            }
        });
        setTouched(touchedFields);

        const isValid = validationSchemas.isValidSync(values);
        if (!isValid) {
            return;
        }

        if (id && kitItemsToDelete.length > 0) {
            for (const itemId of kitItemsToDelete) {
                await dispatch(deleteKitDetails(itemId));
            }
        }
        const submissionValues = {
            ...values,
            KitDetails: values.KitDetails,
        };

        if (id) {
            delete submissionValues.isActive;
            delete submissionValues.createdAt;
            delete submissionValues.updatedAt;
            dispatch(editKitProduct({ id: values._id, ...submissionValues }));
        } else {
            dispatch(addKitProduct({ data: submissionValues }));
            dispatch(getKitProduct());
        }
        setDeletedItems([]);
        setKitItemsToDelete([]);
        navigate('/admin/kit-product');
        resetForm();
    };

    const formik = useFormik({
        initialValues: { ...initialValues, KitDetails: kitdata },
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });
    const [deletedItems, setDeletedItems] = useState([]);
    const [kitItemsToDelete, setKitItemsToDelete] = useState([]);
    const { handleBlur, handleChange, values, touched, errors, setFieldValue, resetForm, setValues } = formik;

    const handleCategoryChange = (index, value) => {
        formik.setFieldValue(`KitDetails[${index}].KitCatogory`, value);
        formik.setFieldValue(`KitDetails[${index}].KitSubCatogory`, "");
        formik.setFieldValue(`KitDetails[${index}].KitProductName`, "");

        const productsForCategory = productData?.filter(product => product.mainCategoryData?.[0]?._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForCategory || [];
            return newFilteredProducts;
        });
    };

    const handleSubCategoryChange = (index, value) => {
        formik.setFieldValue(`KitDetails[${index}].KitSubCatogory`, value);
        const productsForSubcategory = productData?.filter(product => product.subCategoryData?.[0]?._id === value);

        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForSubcategory || [];
            return newFilteredProducts;
        });
    };
    const handleProductChange = (index, value) => {
        formik.setFieldValue(`KitDetails[${index}].KitProductName`, value);
        const product = productData?.find(product => product._id === value);
        if (product) {
            formik.setFieldValue(`KitDetails[${index}].KitDiscription`, product.Desacription);
            formik.setFieldValue(`KitDetails[${index}].KitUnit`, product.unitOfMeasurement);
        }
    }


    const handleAddKit1 = (index) => {
        const oldKitDetails = [...values.KitDetails];
        const newKit = {
            KitCatogory: '',
            KitSubCatogory: '',
            KitProductName: '',
            KitDiscription: '',
            KitUnit: '',
            KitQty: '',
        };

        oldKitDetails.splice(index + 1, 0, newKit);
        const productsForCategory = productData;
        const filter = [...filteredProducts];
        filter.splice(index + 1, 0, productData)
        setFilteredProducts(filter);

        formik.setFieldValue('KitDetails', oldKitDetails);

        formik.setTouched({
            KitDetails: oldKitDetails.map((_, i) => ({
                KitCatogory: i === index + 1 ? false : touched.KitDetails?.[i]?.KitCatogory,
                KitSubCatogory: i === index + 1 ? false : touched.KitDetails?.[i]?.KitSubCatogory,
                KitProductName: i === index + 1 ? false : touched.KitDetails?.[i]?.KitProductName,
                KitDiscription: i === index + 1 ? false : touched.KitDetails?.[i]?.KitDiscription,
                KitUnit: i === index + 1 ? false : touched.KitDetails?.[i]?.KitUnit,
                KitQty: i === index + 1 ? false : touched.KitDetails?.[i]?.KitQty,
            })),
        });
    };


    const [openDialog, setOpenDialog] = useState(false);
    const [currentDeleteIndex, setCurrentDeleteIndex] = useState(null);

    const handleDeleteKit = (index) => {

        setCurrentDeleteIndex(index);
        setOpenDialog(true);
    };

    const confirmDeleteKit = () => {
        const index = currentDeleteIndex;
        const kitDetail = values.KitDetails[index];

        if (kitDetail._id) {
            setKitItemsToDelete((prev) => [...prev, kitDetail._id]);
        }

        setDeletedItems((prev) => [...prev, { index, item: kitDetail }]);
        const updatedKitDetails = [...values.KitDetails];
        updatedKitDetails.splice(index, 1);
        setkitdata(updatedKitDetails);
        formik.setFieldValue('KitDetails', updatedKitDetails);

        setOpenDialog(false);
        setCurrentDeleteIndex(null);
    };

    const cancelDeleteKit = () => {

        setOpenDialog(false);
        setCurrentDeleteIndex(null);
    };
    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE KIT PRODUCT"
                    subtitle="Update Your Kit product Here"
                />
            ) : (
                <Header
                    title="ADD KIT PRODUCT"
                    subtitle="Manage Your Kit product Here"
                />
            )}

            <form onSubmit={formik.handleSubmit} enctype="multipart/form-data">
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}>
                        <FormControl variant="filled" sx={{ minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Kit Name :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.KitName}
                                name="KitName"
                                error={!!touched.KitName && !!errors.KitName}
                                helperText={touched.KitName && errors.KitName}
                                sx={{ gridColumn: "span 2" }}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Box sx={{ overflowX: "auto", width: "100%" }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow >
                                        <TableCell sx={{ width: "70px", fontSize: "14px" }} > Sr No</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Sub Category</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Product Name</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Description</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }} >Unit of Measurement</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {values.KitDetails &&
                                        values.KitDetails.map((kit, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ width: 50 }}>
                                                    {index + 1}
                                                </TableCell>
                                                {/* Category */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`KitDetails.${index}.KitCatogory`}
                                                        onChange={(e) => handleCategoryChange(index, e.target.value)}
                                                        value={values.KitDetails?.[index]?.KitCatogory || ""}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitCatogory &&
                                                            !!errors.KitDetails?.[index]?.KitCatogory
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitCatogory &&
                                                            errors.KitDetails?.[index]?.KitCatogory
                                                        }
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {categories?.map((category) => (
                                                            <MenuItem key={category._id} disabled={category._id === "6749c8c7864db29472435057" || category._id === "6749c8bf864db29472435052"} value={category._id}>
                                                                {category.categoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>

                                                {/* Sub Category */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        // label="Sub Category :"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`KitDetails.${index}.KitSubCatogory`}
                                                        onChange={(e) => handleSubCategoryChange(index, e.target.value)}
                                                        value={values.KitDetails?.[index]?.KitSubCatogory || ""}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitSubCatogory &&
                                                            !!errors.KitDetails?.[index]?.KitSubCatogory
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitSubCatogory &&
                                                            errors.KitDetails?.[index]?.KitSubCatogory
                                                        }
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {subcategories
                                                            ?.filter(
                                                                (subcategory) =>
                                                                    subcategory.categoryData?.[0]?._id ===
                                                                    values.KitDetails[index].KitCatogory
                                                            )
                                                            .map((subcategory) => (
                                                                <MenuItem key={subcategory._id} value={subcategory._id}>
                                                                    {subcategory.subCategoryName}
                                                                </MenuItem>
                                                            ))}
                                                    </TextField>
                                                </TableCell>

                                                {/* Product Name */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`KitDetails.${index}.KitProductName`}
                                                        onChange={(e) => handleProductChange(index, e.target.value)}
                                                        value={values.KitDetails?.[index]?.KitProductName}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitProductName &&
                                                            !!errors.KitDetails?.[index]?.KitProductName
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitProductName &&
                                                            errors.KitDetails?.[index]?.KitProductName
                                                        }
                                                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                                                    >
                                                        {filteredProducts[index]?.map((product) => (
                                                            <MenuItem key={product._id} value={product._id}>
                                                                {product.productName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>

                                                {/* Description */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "180px",
                                                                sm: "200px",
                                                                md: "260px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) =>
                                                            setFieldValue(`KitDetails[${index}].KitDiscription`, e.target.value)
                                                        }
                                                        value={values.KitDetails?.[index]?.KitDiscription || ""}
                                                        name={`KitDetails.${index}.KitDiscription`}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitDiscription &&
                                                            !!errors.KitDetails?.[index]?.KitDiscription
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitDiscription &&
                                                            errors.KitDetails?.[index]?.KitDiscription
                                                        }
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </TableCell>

                                                {/* Unit of Measurement */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) =>
                                                            setFieldValue(`KitDetails[${index}].KitUnit`, e.target.value)
                                                        }
                                                        value={values.KitDetails?.[index]?.KitUnit || ""}
                                                        name={`KitDetails.${index}.KitUnit`}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitUnit &&
                                                            !!errors.KitDetails?.[index]?.KitUnit
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitUnit &&
                                                            errors.KitDetails?.[index]?.KitUnit
                                                        }
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </TableCell>

                                                {/* Quantity */}
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) =>
                                                            setFieldValue(`KitDetails[${index}].KitQty`, e.target.value)
                                                        }
                                                        value={values.KitDetails?.[index]?.KitQty || ""}
                                                        name={`KitDetails.${index}.KitQty`}
                                                        error={
                                                            !!touched.KitDetails?.[index]?.KitQty &&
                                                            !!errors.KitDetails?.[index]?.KitQty
                                                        }
                                                        helperText={
                                                            touched.KitDetails?.[index]?.KitQty &&
                                                            errors.KitDetails?.[index]?.KitQty
                                                        }
                                                    />
                                                </TableCell>

                                                <TableCell>
                                                    <Stack spacing={2} direction="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => handleAddKit1(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <AddIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleDeleteKit(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "16px" }} />
                                                        </Button>


                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Dialog
                        open={openDialog}
                        onClose={cancelDeleteKit}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete this item? This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={cancelDeleteKit} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button onClick={confirmDeleteKit} color="error" autoFocus>
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Box display="flex" justifyContent="flex-end" m={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleAddKit}
                        >
                            Add Kit Product
                        </Button>
                    </Box>
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                type="submit"
                            >
                                {id ? 'Update' : 'Submit'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack>
            </form>
        </Box >
    );
}

export default AddKitProduct
